import React from 'react';
import styled from 'styled-components';
import Bars from 'icons/src/Bars';

const Button = ({ children, className, onClick }) => (
  <button onClick={onClick} type="button" className={className}>
    {children || <Bars />}
  </button>
);

export default styled(Button)`
  display: flex;
  padding: 0;
  margin: 0;
  background: none;
  border: none;
  @media all and (min-width: ${({ navBreakpoint }) => navBreakpoint}) {
    display: none;
  }
  svg {
    width: 1.5rem;
  }
`;
